module.exports = __webpack_public_path__ + "static/media/ve.69056e47.svg";